import Grid from '@mui/material/Unstable_Grid2'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import {
  CountryMultiAutocomplete,
  CustomTextField,
  PostalcodeAutocomplete,
  ProvinceAutocomplete,
  TownAutocomplete
} from '../../../../../../shared/components/inputs'
import { IUser, ROLES } from '../../../../models/user'

interface CenterTabProps {
  user: IUser
  handleInputChange: (inputName: string, value: any) => void
}

export function CenterTab({ user, handleInputChange }: CenterTabProps) {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={6}>
        <CustomTextField
          inputName={'centerName'}
          value={user.centerName}
          handleInputChange={handleInputChange}
          required
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <CustomTextField inputName={'address'} value={user.address} handleInputChange={handleInputChange} />
      </Grid>

      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6}>
          <CountryMultiAutocomplete value={user.countries} handleInputChange={handleInputChange} />
        </Grid>
      )}

      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6}>
          <ProvinceAutocomplete value={user.province} country={user.countries} handleInputChange={handleInputChange} />
        </Grid>
      )}

      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6}>
          <TownAutocomplete value={user.town} province={user.province} handleInputChange={handleInputChange} />
        </Grid>
      )}

      {authUser.role_id !== ROLES.client && (
        <Grid xs={12} sm={6}>
          <PostalcodeAutocomplete
            value={user.postalcode}
            province={user.province}
            handleInputChange={handleInputChange}
          />
        </Grid>
      )}
    </Grid>
  )
}
